import { RecoverForm } from "@/features/recover/components/form";
import { Page } from "@/types/generics";
import { Layout } from "@/ui/layouts";
import { GetServerSideProps } from "next";

type Props = Page;
export function Recover(props: Props) {
  return (
    <Layout meta={props.meta}>
      <RecoverForm />
    </Layout>
  );
}

export default Recover;

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  return {
    props: {
      data: null,
      meta: { title: "Recuperar contraseña | Servicom", description: "" },
    },
  };
};
